import {createContext} from "react";
import { CreateStateManager, StateManager } from "./PartyState";

export const StateManagerContext = createContext<StateManager>((()=> {
    const sm = CreateStateManager(undefined);
    console.log('Statemanager created as default id =' + sm.getObjId());

    return sm;
})());